import React, { useState, useContext, createContext, useEffect } from "react";
import PropTypes from "prop-types";

const DefaultsContext = createContext(undefined);

export function DefaultsProvider({ children }) {
  const [defaultBrand, setDefaultBrand] = useState("");

  useEffect(() => {
    setDefaultBrand("NIVEA");
  }, []);

  return (
    <DefaultsContext.Provider
      value={{
        defaultBrand,
        setDefaultBrand,
      }}
    >
      {children}
    </DefaultsContext.Provider>
  );
}

export function useDefaults() {
  const context = useContext(DefaultsContext);
  if (context === undefined) {
    throw new Error("useDefaults must be used within a DefaultsProvider");
  }
  return context;
}

DefaultsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
